export interface Notification {
  type: string;
  text: string | React.ReactElement;
}

export interface SupportedLanguage {
  value: string;
  displayValue: string;
}

export interface AppState {
  notifications: {
    lastIndex?: number;
    queue: Notification[];
  };
  supportedLanguages: SupportedLanguage[];
  help: {
    show: boolean;
    id: string;
  };
  isLoading: boolean;
  loadingText?: string;
}

/** Redux types */

export const SHOW_NOTIFICATION = 'SHOW_NOTIFICATION';
export const HIDE_NOTIFICATION = 'HIDE_NOTIFICATION';
export const SHOW_ERROR_NOTIFICATION = 'SHOW_ERROR_NOTIFICATION';
export const ADD_ERROR = 'ADD_ERROR';
export const IS_LOADING = 'IS_LOADING';
export const SHOW_HELP = 'SHOW_HELP';
export const HIDE_HELP = 'HIDE_HELP';
export const SET_LOADING_TEXT = 'SET_LOADING_TEXT';

/** Action Types */

type ShowNotificationAction = {
  type: typeof SHOW_NOTIFICATION;
  message: string | React.ReactElement;
}

type HideNotificationAction = {
  type: typeof HIDE_NOTIFICATION;
}

type ShowErrorNotificationAction = {
  type: typeof SHOW_ERROR_NOTIFICATION;
  message: string | React.ReactElement;
}

type ReportErrorAction = {
  type: typeof ADD_ERROR;
  error: string | React.ReactElement;
}

type SetLoadingAction = {
  type: typeof IS_LOADING;
  isLoading: boolean;
}

type ShowHelpAction = {
  type: typeof SHOW_HELP;
  helpId: string;
}

type HideHelpAction = {
  type: typeof HIDE_HELP;
}

type ShowLoadingTextAction = {
  type: typeof SET_LOADING_TEXT;
  payload: string;
}

export type AppActionTypes =
  ShowNotificationAction |
  HideNotificationAction |
  ShowErrorNotificationAction |
  ReportErrorAction |
  SetLoadingAction |
  ShowHelpAction |
  HideHelpAction |
  ShowLoadingTextAction;
